export default __webpack_public_path__ + "static/media/value4.2ee4515a.png";